export class PagedRequest {
  public Skip: number;
}
